import { GetterTree } from "vuex";
import { RootState } from "@/store/types";

import { BusinessState } from "@/modules/businesses/types";

const getters: GetterTree<BusinessState, RootState> = {
  getCurrentBusinessOwners: (state) => state.currentBusinessOwners,
  getAllBusinesses: (state) => state.businesses,
  getSelectedBusiness: (state) => state.selectedBusiness,
  getCurrentBusiness: (state) => state.currentBusiness,
  getAllApprovedBusinesses: (state) => state.allApprovedBusinesses,
  getAllRejectedBusinesses: (state) => state.allRejectedBusinesses,
  getAllPendingBusinesses: (state) => state.allPendingBusinesses,
  isViewing: (state) => state.isViewing,
  isAllBusinessesEmpty: (state) => state.businesses.items.length === 0,
  isApprovedBusinessesEmpty: (state) =>
    state.allApprovedBusinesses.items.length === 0,
  isRejectedBusinessesEmpty: (state) =>
    state.allRejectedBusinesses.items.length === 0,
  isPendingBusinessesEmpty: (state) =>
    state.allPendingBusinesses.items.length === 0,
  getSortOrder: (state) => state.sortOrder,
  getSortBy: (state) => state.sortBy,
  getIsFetchingBusinesses: (state) => state.isFetchingBusinesses,
  getIsFetchingBusinessOwners: (state) => state.isFetchingBusinessOwners,
  query: (state) => state.query,
};

export default getters;
